import { useContext, useEffect, useRef, useState } from 'react';
import { marked } from 'marked';
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import ModalContext from '../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import ModalLink from '../components/ModalLink';
import useRouting from '../hooks/useRouting';
import Dialog from '@pelckmans/elementis/components/dialog';
import { AppType, getAppTypeById } from '../pages/material/api/appsApi';

export type NotLicensedAppModalProps = {
  id: string;
  appTypeId: string;
};
export default function NotLicensedAppModal({ id, appTypeId }: NotLicensedAppModalProps) {
  const { t } = useTranslation();
  const { r } = useRouting();
  const { closeModal } = useContext(ModalContext);

  const splideRef = useRef<Splide>(null);

  const [appType, setAppType] = useState<AppType>();

  useEffect(() => {
    const fetchAppType = async () => {
      const { data } = await getAppTypeById(appTypeId);

      setAppType(data);
    };

    fetchAppType();
  }, [appTypeId]);

  if (!appType) return null;

  return (
    <Dialog
      id={id}
      modal
      aria-label={t('SHARED_COMPONENTS.APP_MODALS.NOT_LICENSED.A11Y_LABEL')}
      onClose={() => closeModal(id)}
      size="sm"
    >
      <Dialog.Header aria-label={t('ACTIONS.CLOSE')} onClose={() => closeModal(id)} title={appType.name} />
      <Dialog.Body>
        <div dangerouslySetInnerHTML={{ __html: marked.parse(appType.description || '') }} />

        {appType.screenshots && appType.screenshots.length > 0 && (
          <Splide
            aria-label="Screenshots"
            hasTrack={false}
            ref={splideRef}
            options={{
              pagination: false,
            }}
          >
            <SplideTrack>
              {appType.screenshots.map(screenshot => {
                return (
                  <SplideSlide key={screenshot}>
                    <img src={`${process.env.REACT_APP_P_API_URL}/api/files/${screenshot}`} alt={appType.name} />
                  </SplideSlide>
                );
              })}
            </SplideTrack>
            <div className="splide__arrows">
              <button className="splide__arrow splide__arrow--prev" />
              <button className="splide__arrow splide__arrow--next" />
            </div>
          </Splide>
        )}
      </Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsRight={{
          role: undefined,
          'aria-label': t('SHARED_COMPONENTS.APP_MODALS.NOT_LICENSED.FOOTER.ACTIONS.A11Y_LABEL'),
          children: (
            <ModalLink
              id={id}
              to={`${r('dashboard')}?showLicenseActivation`}
              className="bc-button__button activate-license-btn bc-button__primary bc-button__small"
            >
              {t('SHARED_COMPONENTS.APP_MODALS.NOT_LICENSED.ACTIONS.ACTIVATE_LICENSE')}
            </ModalLink>
          ),
        }}
      ></Dialog.Footer>
    </Dialog>
  );
}
